var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLinePoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12 3a9 9 0 1 1-.001 18.001A9 9 0 0 1 12 3zm.14 4.932-.825.001H9.581c-.044 0-.087-.002-.13.003-.252.024-.39.231-.377.4.004.044 0 .087 0 .131l.002 7.97c0 .045-.008.09.003.131.02.071.038.147.078.207.078.117.2.163.339.164h.7c.207 0 .413.002.619 0 .264-.003.43-.169.435-.43v-.13l.002-2.127c0-.15.012-.162.161-.165h.048l1.461.004c.315 0 .624-.037.926-.127a3.075 3.075 0 0 0 2.158-3.508 3.013 3.013 0 0 0-1.133-1.866 3.038 3.038 0 0 0-1.906-.656c-.55-.005-1.101-.001-1.652-.001zm-.016 1.887.712.003a1.18 1.18 0 0 1 1.179 1.148c.02.702-.496 1.15-1.011 1.214-.095.012-.19.018-.284.019-.42.002-.84 0-1.259 0h-.095c-.085-.009-.111-.034-.113-.12-.002-.167 0-.333 0-.5V9.981c0-.14.02-.16.158-.16.475-.001.95-.005 1.425.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h228v44H-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinePoints);
export default __webpack_public_path__ + "static/media/ic-line-points.b52edc30303c46f28a8fa25b3b3eec64.svg";
export { ForwardRef as ReactComponent };